<template>
  <ExercisesPageComponent :entry="entry" />
</template>
<script>
import gql from 'graphql-tag';
import { stripLocale } from '@/utils/i18n';
import { isFiltersQuery, enrichBlocksWithExerciseData } from '@/utils/algolia';
import entryPage, { SeomaticFragment, EntryPageFragment } from '@/mixins/entryPage';
import ExercisesPageComponent, { ExercisePageFragment } from '@/components/exercises/ExercisesPage';

export const ExercisesPageQuery = gql`
  query ExercisesPageQuery($site: String!, $uri: String!) {
    entry(section: "exercises", site: [$site], uri: [$uri]) {
      title
      ...EntryPageFragment
      ...ExercisePageFragment
    }

    seomatic(site: $site, uri: $uri, asArray: true) {
      ...SeomaticFragment
    }
  }
  ${EntryPageFragment}
  ${ExercisePageFragment}
  ${SeomaticFragment}
`;
export const asyncData = async function ({ $craftRequest, $retourRedirect, app, route, $algoliaWorkouts }) {
  const { locale } = app.i18n;
  const uri = stripLocale(route.path, locale);
  const variables = { site: locale, uri };
  const { entry, seomatic } = await $craftRequest(ExercisesPageQuery, variables);

  if (entry === null) {
    return $retourRedirect();
  }

  // enrich blocks with algolia exercise data
  await enrichBlocksWithExerciseData(entry.exercisesBlocks, $algoliaWorkouts);

  return { entry, seomatic };
};

export default {
  name: 'ExercisesCatchallIndex',
  components: { ExercisesPageComponent },
  mixins: [entryPage],
  asyncData,
  computed: {
    gtmMeta() {
      const options = { content_category: 'exercises' };
      if (isFiltersQuery(this.$route.query)) options.page_type = this.entry?.pageProfile;
      return options;
    },
  },
  mounted() {
    this.setBreadCrumb();

    this.gtmPushPageMeta(this.gtmMeta);
  },
};
</script>
